// extracted by mini-css-extract-plugin
export var buttonContainer = "_52-1";
export var fontSizeSelect = "_52-3";
export var formatSelect = "_52-2";
export var formats = "_52-4";
export var hidden = "_52-5";
export var icon = "_52-6";
export var select = "_52-0";